import React from "react";
import Seo from "../../components/Seo";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-14">
      <Seo title="About" description="COMMITMENTT helps you see what your money is already committed to — EMIs, rent, subscriptions, insurance, bills, loans and more — so you can plan what comes next and stay ahead." />
      <span className="text-xs tracking-[0.2em] uppercase font-semibold text-mint">About</span>
      <h1 className="font-heading text-4xl font-light text-ink mt-3">See what your money is committed to.</h1>
      <div className="prose prose-slate mt-6 space-y-5 text-slatey leading-relaxed">
        <p>
          Every month, a part of your income is already spoken for. EMIs, rent, subscriptions, insurance, bills, loans,
          BNPL instalments, autopays and shared plans each claim a piece of your salary — often automatically, and often
          before you notice.
        </p>
        <p>
          Most finance apps look backward, telling you what you already spent. COMMITMENTT looks forward: it brings your
          recurring commitments into one place so you can see what you have already <em>committed</em> to pay, understand
          what is due next, and make better-informed decisions before taking on something new.
        </p>
        <p>
          It is built around a simple idea — know what you have committed, plan what comes next, and stay ahead. The goal
          is to make that clarity useful for anyone, even someone with no financial background.
        </p>
        <p>
          COMMITMENTT is currently in Early Access — a functioning product being actively refined with its earliest users.
          Your genuine usage and feedback directly shape what we build next.
        </p>
        <p className="text-sm text-muted-foreground">
          COMMITMENTT is not a bank and does not provide financial advice. Estimates are based on the information you
          provide and confirm, and no bank credentials are ever required.
        </p>
      </div>
    </div>
  );
}
